import { Button, Dialog, DialogActions, DialogContent } from "@mui/material";
import { useContext, useRef, useState } from "react";
import { UsinasContext } from "../context/UsinasContextProvider";
import { DialogHeader } from "../../../auth/components/PasswordRecoveryModal";
import { ConfirmationModal } from "../../../main/components/ConfirmationModal";
import { UsinaNameEditForm } from "./UsinaNameEditForm";
import { usinasApi } from "../../../services/api";
// import { ErrorModal } from "../../../main/components/ErrorModal";
import { ActionAlert } from "../../../main/components/alerts/ActionAlert";

export function EditUsinaNameModal(props: {
  open: boolean;
  setOpen: (open: boolean) => void;
}) {
  const { usina, setUsina } = useContext(UsinasContext);

  const { open, setOpen } = props;
  const [newName, setNewName] = useState<string>("");
  const [openEditConfirmationModal, setOpenEditConfirmationModal] =
    useState(false);
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [canEdit, setCanEdit] = useState(false);
  const usinaId = usina && "usinaIds" in usina ? usina.usinaIds.id : "";
  const onClose = () => setOpen(false);

  const formRef = useRef<HTMLFormElement | null>(null);
  const handleFormSubmit = async () => {
    if (formRef.current) formRef.current.submitForm();
  };
  return (
    <>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        maxWidth="sm"
      >
        <DialogHeader id="customized-dialog-title" onClose={onClose}>
          Editar Nome da Usina
        </DialogHeader>
        <DialogContent dividers sx={{ width: "450px", height: "120px" }}>
          <UsinaNameEditForm
            open={open}
            setCanEdit={setCanEdit}
            setNewName={setNewName}
            setOpenConfirmNameEditModal={setOpenEditConfirmationModal}
            ref={formRef}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Fechar</Button>
          <Button
            disabled={!canEdit}
            variant="contained"
            color="primary"
            onClick={handleFormSubmit}
          >
            Editar Nome
          </Button>
        </DialogActions>
      </Dialog>

      <ConfirmationModal
        open={openEditConfirmationModal}
        setOpen={setOpenEditConfirmationModal}
        title="Editar Nome da Usina"
        contentText="Deseja confirmar a edição do nome da Usina?"
        onConfirm={async () => {
          await usinasApi.patchUsinaName(usinaId, newName);
          const updatedUsina = await usinasApi.getUsina(usinaId);
          setUsina(updatedUsina);
        }}
        setOpenErrorModal={setOpenErrorModal}
        setOpenSuccessModal={setOpenSuccessModal}
      />

      <ActionAlert
        message="O nome da Usina foi editado com sucesso!"
        severity="success"
        open={openSuccessModal}
        setOpen={setOpenSuccessModal}
        onClose={() => {
          setOpen(false);
        }}
      />
      <ActionAlert
        message="Ocorreu um erro ao editar o nome da Usina, tente novamente mais tarde."
        severity="error"
        open={openErrorModal}
        setOpen={setOpenErrorModal}
        onClose={() => {
          setOpen(false);
        }}
      />
      {/* <SuccessModal
        open={openSuccessModal}
        setOpen={setOpenSuccessModal}
        title="Nome da Usina Editado com Sucesso!"
        contentText="O nome da Usina foi editado com sucesso!"
        onClose={() => {
          setOpen(false);
        }}
      />
      <ErrorModal
        open={openErrorModal}
        setOpen={setOpenErrorModal}
        title="Erro ao Editar Nome da Usina!"
        contentText="Ocorreu um erro ao editar o nome da Usina, tente novamente mais tarde."
        onClose={() => {
          setOpen(false);
        }}
      /> */}
    </>
  );
}
